import { IPatientStore } from './types';

const initStore: IPatientStore = {
  personalData: null,
  overviewFilters: null,
  info: null,
  latestReadings: null,
};

export default initStore;
